import Components from "slotworks/components/components";
import AutoplayModel from "slotworks/model/autoplay/autoplay-model";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import Contract from "slotworks/utils/contracts/contract";

export class Autoplay {
    public start() {
        AutoplayModel.confirm();
    }

    public spin() {
        if (AutoplayModel.decrease() <= 0) {
            this.complete();
        }
    }

    public updateWinLoss() {
        const win = GameState.getCurrentGame().getCurrentTotalWin();
        const winLoss = GameState.getCurrentGame().getTotalWinLoss();

        if (AutoplayModel.isAutoPlaying()) {
            if (AutoplayModel.stopOnAnyWin && win > 0) {
                this.stop();
            } else {
                AutoplayModel.runningWinLoss += winLoss;
                const nextSpinWinLoss = AutoplayModel.runningWinLoss - BetModel.getTotalStake();

                const isOverLossLimit = AutoplayModel.lossLimit.currentValue > 0 && nextSpinWinLoss <= -AutoplayModel.lossLimit.currentValue;
                const isOverSingleWinLimit = AutoplayModel.singleWinLimit.currentValue > 0 && winLoss > AutoplayModel.singleWinLimit.currentValue;
                const isOverTotalWinLimit = AutoplayModel.totalWinLimit.currentValue > 0 && AutoplayModel.runningWinLoss >= AutoplayModel.totalWinLimit.currentValue;

                return this.limitReached(isOverLossLimit, isOverSingleWinLimit, isOverTotalWinLimit);
            }
        }

        return Contract.empty();
    }

    public stop() {
        AutoplayModel.stop();
        SmartUIFlags.set(SmartUIFlag.AUTO_SPIN, false);
    }

    public complete() {
        this.stop();
    }

    public setEnabled(enabled: boolean) {
        AutoplayModel.enabled = enabled;
    }

    public isEnabled() {
        return AutoplayModel.enabled;
    }

    protected limitReached(isOverLossLimit: boolean, isOverSingleWinLimit: boolean, isOverTotalWinLimit: boolean, message?: string) {
        if (isOverSingleWinLimit || isOverLossLimit || isOverTotalWinLimit) {

            this.stop();

            if (!message) {
                let messageTag;
                if (isOverSingleWinLimit) {
                    messageTag = "aut.swl";
                }
                if (isOverLossLimit) {
                    messageTag = "aut.lol";
                }
                if (isOverTotalWinLimit) {
                    messageTag = "aut.twl";
                }

                if (messageTag) {
                    message = Services.translations.get(messageTag);
                }

                if (message === messageTag) {
                    message = null;
                }
            }

            if (message) {
                return new Contract<void>((resolve) => {
                    SmartUIFlags.set(SmartUIFlag.PROMPT, true);
                    Components.alert.info(message).then(() => {
                        SmartUIFlags.set(SmartUIFlag.PROMPT, false);
                        resolve();
                    });
                });
            }
        }

        return Contract.empty();
    }
}
